import navigate_to_org from 'assets/images/guides/buy-sub/navigate-to-org-1.png';
import buy_sub_2 from 'assets/images/guides/buy-sub/buy-sub-2.png';
import buy_sub_3 from 'assets/images/guides/buy-sub/buy-sub-3.png';
import buy_sub_4 from 'assets/images/guides/buy-sub/buy-sub-4.png';

export const purchase_subscription = [
  {
    caption: 'Open `Organisations` from the menu on the left of your screen.',
    image: navigate_to_org
  },
  {
    caption: 'Find the client, open its actions menu and select `Buy subscription`.',
    image: buy_sub_2
  },
  {
    caption: 'Choose a plan and the contact bracket that fits the client.',
    image: buy_sub_3
  },
  {
    caption: 'Review the details, then click `Proceed to payment` to activate the subscription.',
    image: buy_sub_4
  }
];
